import React, { ReactNode } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CustomAccordionProps {
  title: string;
  expanded?: boolean;
  onChange?: (event: React.SyntheticEvent, isExpanded: boolean) => void;
  children: ReactNode;
  defaultExpanded?: boolean;
  elevation?: number;
  sx?: Record<string, any>;
}

export const CustomAccordion: React.FC<CustomAccordionProps> = ({
  title,
  expanded,
  onChange,
  children,
  defaultExpanded = false,
  elevation = 0,
  sx = {},
}) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      defaultExpanded={defaultExpanded}
      elevation={elevation}
      sx={{
        boxShadow: elevation > 0 ? undefined : 'none',
        border: elevation > 0 ? 'none' : '1px solid',
        borderColor: elevation > 0 ? 'transparent' : 'divider',
        backgroundColor: 'background.paper',
        color: 'text.primary',
        '&:before': {
          display: 'none',
        },
        '&.Mui-expanded': {
          margin: 0,
        },
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: 'background.paper',
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          '&.Mui-expanded': {
            backgroundColor: 'background.paper',
            minHeight: 48,
          },
          '& .MuiAccordionSummary-content': {
            margin: '12px 0',
            '&.Mui-expanded': {
              margin: '12px 0',
            },
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            color: 'text.secondary',
            '&.Mui-expanded': {
              color: 'primary.main',
            },
          },
        }}
      >
        <Typography variant="h6" component="div" sx={{ color: 'text.primary' }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: 0,
          backgroundColor: 'background.paper',
          color: 'text.primary',
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
